<template>
  <div
    class="tw-px-8 tw-pb-6"
  >
    <v-timeline
      align-top
      dense
    >
      <v-timeline-item
        color="white"
        class="k-timeline-item"
        large
      >
        <template
          #icon
          class="test"
        >
          <span class="tw-text-sm">9:15 am</span>
        </template>
        <v-layout pt-3>
          <v-flex>
            <strong class="tw-text-base">{{ $faker().lorem.sentence() }}</strong>
            <div class="caption">
              {{ $faker().lorem.sentence() }}
            </div>
          </v-flex>
        </v-layout>
      </v-timeline-item>

      <v-timeline-item
        color="teal lighten-3"
        small
      >
        <v-layout
          wrap
          pt-3
        >
          <v-flex xs2>
            <strong>3-4pm</strong>
          </v-flex>
          <v-flex>
            <strong>Design Stand Up</strong>
            <div class="caption mb-2">
              Hangouts
            </div>
            <v-avatar>
              <v-img
                src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown"
              />
            </v-avatar>
            <v-avatar>
              <v-img
                src="https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Black&eyeType=Default&eyebrowType=FlatNatural&mouthType=Default&skinColor=Tanned"
              />
            </v-avatar>
            <v-avatar>
              <v-img
                src="https://avataaars.io/?avatarStyle=Circle&topType=LongHairMiaWallace&accessoriesType=Sunglasses&hairColor=BlondeGolden&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Surprised&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Pale"
              />
            </v-avatar>
          </v-flex>
        </v-layout>
      </v-timeline-item>

      <v-timeline-item
        color="pink"
        small
      >
        <v-layout pt-3>
          <v-flex xs2>
            <strong>12pm</strong>
          </v-flex>
          <v-flex>
            <strong>Lunch break</strong>
          </v-flex>
        </v-layout>
      </v-timeline-item>

      <v-timeline-item
        color="teal lighten-3"
        small
      >
        <v-layout pt-3>
          <v-flex xs2>
            <strong>9-11am</strong>
          </v-flex>
          <v-flex>
            <strong>Finish Home Screen</strong>
            <div class="caption">
              Web App
            </div>
          </v-flex>
        </v-layout>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<script>
    export default {
        data() {
            return {
                opportunities: [
                    {
                        contact: 'Opportunity 1',
                        value: '$9000.00',
                        type: 'RENT',
                    },
                ],
            };
        },
    };
</script>
<style lang="scss" scoped>
 .v-timeline-item__dot{
    background: red;
     box-shadow: none !important;
     -webkit-box-shadow: none !important;
     border: none;
  }
</style>
